export const admissionHero = {
  title: '入学案内',
  titleEn: 'ADMISSION',
  lead: '日本執事アカデミーへの入学は、資料請求・個別相談から無理なくお進みいただけます。',
};

export const admissionFlowSteps = [
  {
    step: '01',
    title: '資料請求',
    titleEn: 'Request Brochure',
    description: 'まずは無料の資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお届けします。',
    icon: 'ri-file-text-line',
    required: false,
  },
  {
    step: '02',
    title: '個別相談',
    titleEn: 'Consultation',
    description: '経験豊富なスタッフが、ご目標やご経験に合わせた最適なコース選びをサポートします。オンラインでも承ります。',
    icon: 'ri-chat-3-line',
    required: false,
  },
  {
    step: '03',
    title: '申込',
    titleEn: 'Apply',
    description: 'コースが決まりましたら、所定の申込フォームよりお手続きください。先着順でお受けします。',
    icon: 'ri-edit-line',
    required: true,
  },
  {
    step: '04',
    title: '受講契約',
    titleEn: 'Contract',
    description: 'お申込み後、受講契約のご案内をお送りします。内容をご確認のうえ、ご契約手続きをお願いします。',
    icon: 'ri-file-copy-line',
    required: true,
  },
  {
    step: '05',
    title: 'お支払い',
    titleEn: 'Payment',
    description: '銀行振込（一括）にて、開校14日前までにお振込みください。入金確認をもって受講が確定します。',
    icon: 'ri-bank-line',
    required: true,
  },
  {
    step: '06',
    title: '受講確定',
    titleEn: 'Enrollment',
    description: '入金確認後、受講確定のご連絡とともに、初回授業の詳細をご案内します。いよいよ学びの始まりです。',
    icon: 'ri-check-double-line',
    required: true,
  },
];

export const guideCards = [
  {
    title: '応募資格・申込の流れ',
    titleEn: 'Application Guide',
    description: '入学に必要な資格や、申込から受講確定までの具体的な手続きの流れを詳しくご案内します。まずは応募資格をご確認ください。',
    icon: 'ri-user-star-line',
    href: '/application',
    imageAlt: '応募書類と筆記具を手にした受講希望者',
  },
  {
    title: '申込フォーム',
    titleEn: 'Application Form',
    description: 'コースをお決めの方は、こちらから直接お申込みいただけます。必要事項を入力し、先着順での受付となります。',
    icon: 'ri-edit-box-line',
    href: '/apply',
    imageAlt: '申込フォームを開いたタブレット端末',
  },
  {
    title: '個別相談予約',
    titleEn: 'Consultation',
    description: '「どのコースが自分に合うか知りたい」「まずは話を聞いてみたい」という方へ。無料・オンライン可の個別相談を承ります。',
    icon: 'ri-calendar-check-line',
    href: '/consultation',
    imageAlt: '個別相談を受ける来訪者と講師',
  },
  {
    title: '体験講座',
    titleEn: 'Trial Seminar',
    description: '実際の授業を1日で体験できる講座です。執事の所作に触れ、アカデミーの雰囲気を体感いただけます。',
    icon: 'ri-lightbulb-line',
    href: '/seminar',
    imageAlt: '体験講座での実習の様子',
  },
];

export const keyPoints = [
  {
    label: '応募資格',
    value: '18歳以上（国籍・性別・経験不問）',
    icon: 'ri-user-line',
  },
  {
    label: '定員',
    value: '各コース 6名（先着順）',
    icon: 'ri-group-line',
  },
  {
    label: '最少催行人数',
    value: '3名',
    icon: 'ri-team-line',
  },
  {
    label: 'お支払い方法',
    value: '銀行振込（一括払いのみ）',
    icon: 'ri-bank-card-line',
  },
  {
    label: '申込締切',
    value: '開校日の14日前',
    icon: 'ri-calendar-line',
  },
  {
    label: '授業形態',
    value: '土日開催・1日6時間（90分×4コマ）',
    icon: 'ri-time-line',
  },
  {
    label: '会場',
    value: '東京都江東区青海（お台場エリア）',
    icon: 'ri-map-pin-line',
  },
];

export const reassuranceItems = [
  {
    title: '未経験でも大丈夫です',
    titleEn: 'No Experience Required',
    description: '全コース、未経験者を歓迎しています。エッセンシャルコースでは基礎の所作から段階的に学べるカリキュラムを採用しており、18歳以上であればどなたでもご受講いただけます。経験や経歴を問う入学選考もございません。',
    icon: 'ri-emotion-happy-line',
  },
  {
    title: '働きながら通えます',
    titleEn: 'Work While Learning',
    description: '全コースを土日開催としており、平日にお勤めの方でも無理なく通学いただけます。エッセンシャルコースは1ヶ月（8日間）、アドバンスコースは2ヶ月（12日間）、マスターコースは3ヶ月（16日間）の日程で、計画的な受講が可能です。',
    icon: 'ri-calendar-2-line',
  },
  {
    title: 'まずは体験できます',
    titleEn: 'Try Before You Decide',
    description: '「いきなり申込みは不安」という方のために、1日完結の体験講座をご用意しています。また、無料の個別相談（オンライン可）では、経験豊富なスタッフがあなたの疑問や不安にじっくりお答えします。',
    icon: 'ri-lightbulb-flash-line',
  },
];

export const admissionFaqs = [
  {
    question: '入学までの流れを教えてください。',
    answer: '資料請求や個別相談（いずれも任意）を経て、申込フォームのご提出、受講契約、お支払い、受講確定という流れです。',
  },
  {
    question: '入学に試験はありますか？',
    answer: '入学選考はありません。18歳以上・経験不問で、先着順（定員6名）に受け付けます。',
  },
  {
    question: 'まず相談だけでもできますか？',
    answer: 'はい。オンライン可・無料の個別相談を承っています。体験講座で実際の授業を体験することもできます。',
  },
  {
    question: '受講に年齢や経験の制限はありますか？',
    answer: '18歳以上であれば、国籍・性別・経験を問わずご受講いただけます。エッセンシャルコースは初心者を前提に設計しており、未経験の方も基礎から段階的に学べます。',
  },
  {
    question: '授業はどのような日程・形式ですか？',
    answer: '土日開催で、1日6時間（90分×4コマ）の対面授業を行います。予習・復習用のオンデマンド動画を組み合わせたハイブリッド形式です。校舎は東京都江東区青海（お台場エリア）にあります。',
  },
  {
    question: '定員に達しなかった場合はどうなりますか？',
    answer: '各コースは最少催行人数を3名としています。開校14日前までに3名に達しない場合は、受講料の全額返金、または次期への振替（5%優待付）をお選びいただけます。',
  },
];

export const admissionRelatedPages = [
  {
    title: '応募資格・申込の流れ',
    description: '資格と申込手順',
    href: '/application',
  },
  {
    title: '申込フォーム',
    description: '本科コースのお申込み',
    href: '/apply',
  },
  {
    title: '個別相談予約',
    description: '無料・オンライン可の相談',
    href: '/consultation',
  },
  {
    title: '体験講座',
    description: '1日で執事の所作を体験',
    href: '/seminar',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
];